// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EHzy","title":"styles_title__K5Vhu"};